export default {
  namespaced: true,
  state: {
    login: ''
  },
  getters: {
    getLogin (state) {
      return state.login
    }
  },
  mutations: {
    setLogin (state, login) {
      state.login = login
    }
  }
}
